// Auto-generated from the client's registration guides (scripts/generate_states.py).
// Owner-reviewed per-state shielding requirement pages.
export const STATES = [
  {
    "slug": "alabama",
    "name": "Alabama",
    "guideSlug": "how-to-register-an-x-ray-machine-in-alabama-a-simple-step-by-step-guide",
    "quickAnswer": "Most new fixed X-ray and fluoroscopy rooms need Alabama shielding approval before installation. The facility must also register every X-ray machine before use. Alabama asks applicants to allow at least six weeks for a complete shielding review.",
    "links": [
      {
        "text": "the Fillable Alabama Registration Form",
        "href": "https://www.alabamapublichealth.gov/radiation/assets/medxrayreg.fillable1.pdf"
      },
      {
        "text": "the Alabama Shielding Plan Guide",
        "href": "https://www.alabamapublichealth.gov/radiation/assets/shieldingplanguide.pdf"
      },
      {
        "text": "Alabama\u2019s Medical X-Ray Forms Page",
        "href": "https://www.alabamapublichealth.gov/radiation/forms.html"
      }
    ],
    "extraGuides": [
      {
        "slug": "how-to-register-an-x-ray-machine-in-jefferson-county-alabama-a-simple-step-by-step-guide",
        "name": "Jefferson County Alabama"
      }
    ]
  },
  {
    "slug": "alaska",
    "name": "Alaska",
    "guideSlug": "how-to-register-an-x-ray-machine-in-alaska-a-simple-step-by-step-guide",
    "quickAnswer": "Alaska requires X-ray-producing devices to be registered with the Department of Health. The Radiological Health program uses its facility and device database for facility, device, and vendor records.",
    "links": [
      {
        "text": "Alaska Radiological Health",
        "href": "https://health.alaska.gov/en/division-of-public-health/alaska-public-laboratories/radiological-health/"
      },
      {
        "text": "Alaska Dental X-Ray Device Guidance",
        "href": "https://health.alaska.gov/en/resources/dental-x-ray-devices/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "arizona",
    "name": "Arizona",
    "guideSlug": "how-to-register-an-x-ray-machine-in-arizona-a-simple-step-by-step-guide",
    "quickAnswer": "A new facility files BRC-4. Each healing-arts X-ray machine gets its own BRC-4X. A new machine must be registered within 30 days after installation, and registration is not complete until the application fee is paid.",
    "links": [
      {
        "text": "the New Facility Form (BRC-4)",
        "href": "https://www.azdhs.gov/documents/licensing/radiation-regulatory/xray/registration/xray-brc-4.pdf"
      },
      {
        "text": "the Machine Form (BRC-4X)",
        "href": "https://www.azdhs.gov/documents/licensing/radiation-regulatory/xray/registration/xray-arra-4x.pdf"
      },
      {
        "text": "Arizona\u2019s X-Ray Fee Schedule",
        "href": "https://www.azdhs.gov/documents/licensing/radiation-regulatory/forms/xray-fee-schedule.pdf"
      },
      {
        "text": "the Arizona X-Ray Program",
        "href": "https://www.azdhs.gov/licensing/radiation-regulatory/index.php#xray"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "arkansas",
    "name": "Arkansas",
    "guideSlug": "how-to-register-an-x-ray-machine-in-arkansas-a-simple-step-by-step-guide",
    "quickAnswer": "Arkansas requires a radiation-machine facility to register X-ray equipment. The current facility form directs registrants to file within 30 days after acquiring a radiation machine.",
    "links": [
      {
        "text": "Arkansas RC Form 200",
        "href": "https://healthy.arkansas.gov/wp-content/uploads/RC_FORM_200_Radiation_Machine_Facility_Registration.pdf"
      },
      {
        "text": "the Arkansas X-Ray Program",
        "href": "https://healthy.arkansas.gov/programs-services/licensing-military-member-licensure-permits-plan-reviews/x-ray-program/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "california",
    "name": "California",
    "guideSlug": "how-to-register-an-x-ray-machine-in-california-a-simple-step-by-step-guide",
    "quickAnswer": "Register every radiation machine through the California portal within 30 days after acquisition. California assigns one FAC number to each physical facility address.",
    "links": [
      {
        "text": "Register or Update an X-Ray Facility Online",
        "href": "https://cdph-rhb.powerappsportals.us/"
      },
      {
        "text": "the California New Facility Guide",
        "href": "https://www.cdph.ca.gov/Programs/CEH/DRSEM/CDPH%20Document%20Library/RHB/X-ray/RegGuides/NewFACRegGuide.pdf"
      },
      {
        "text": "Verify an Existing Facility Registration",
        "href": "https://regsearchtool.cdph.ca.gov/"
      },
      {
        "text": "Registration FAQs and Process Guides",
        "href": "https://www.cdph.ca.gov/Programs/CEH/DRSEM/Pages/RHB-X-ray/RegistrationFAQ.aspx"
      },
      {
        "text": "the Los Angeles County Shielding Request",
        "href": "https://admin.publichealth.lacounty.gov/eh/docs/permit/radiation-shielding-plan-check-service-request.pdf"
      },
      {
        "text": "Los Angeles County Electronic Submission Steps",
        "href": "https://admin.publichealth.lacounty.gov/eh/i-want-to/submit-electronic-plan.htm"
      },
      {
        "text": "San Diego County Shielding Instructions",
        "href": "https://www.sandiegocounty.gov/content/dam/sdc/deh/hmd/pdf/HM9900%20rev%2007-16%20%28003%29.pdf"
      },
      {
        "text": "San Diego County Current Fee Page",
        "href": "https://www.sandiegocounty.gov/content/sdc/deh/doing_business/Fees_Radiation_Shielding_Plan_Check.html"
      }
    ],
    "extraGuides": [
      {
        "slug": "how-to-register-an-x-ray-machine-in-los-angeles-county-california-a-simple-step-by-step-guide",
        "name": "Los Angeles County California"
      },
      {
        "slug": "how-to-register-an-x-ray-machine-in-san-diego-county-california-a-simple-step-by-step-guide",
        "name": "San Diego County California"
      }
    ]
  },
  {
    "slug": "colorado",
    "name": "Colorado",
    "guideSlug": "how-to-register-an-x-ray-machine-in-colorado-a-simple-step-by-step-guide",
    "quickAnswer": "Colorado requires non-federal X-ray facilities to register initially and renew annually. New or modified rooms should be evaluated for shielding before installation, and Colorado uses registered service providers and qualified experts for regulated X-ray work.",
    "links": [
      {
        "text": "Colorado X-Ray Machine Facilities",
        "href": "https://cdphe.colorado.gov/index.php/hm/xray-machine-facilities"
      },
      {
        "text": "the Colorado X-Ray Program",
        "href": "https://cdphe.colorado.gov/hm/xray"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "connecticut",
    "name": "Connecticut",
    "guideSlug": "how-to-register-an-x-ray-machine-in-connecticut-a-simple-step-by-step-guide",
    "quickAnswer": "Connecticut requires all diagnostic and therapeutic X-ray devices to be registered before use. Device registrations renew every two years, and the current state fee is $190 per X-ray device.",
    "links": [
      {
        "text": "Connecticut X-Ray Device Registration",
        "href": "https://portal.ct.gov/deep/radiation/diagnostic-and-therapeutic-x-ray-devices"
      },
      {
        "text": "Connecticut DEEP Radiation",
        "href": "https://portal.ct.gov/deep/radiation/radiation"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "delaware",
    "name": "Delaware",
    "guideSlug": "how-to-register-an-x-ray-machine-in-delaware-a-simple-step-by-step-guide",
    "quickAnswer": "A new facility files ORC-R1. Most new or modified installations above 70 kVp also file OE R-15A with shielding plans before construction.",
    "links": [
      {
        "text": "the New Facility Application (ORC-R1)",
        "href": "https://dhss.delaware.gov/wp-content/uploads/sites/12/dph/pdf/radfacapplic.pdf"
      },
      {
        "text": "the Shielding Plan Review Application (OE R-15A)",
        "href": "https://dhss.delaware.gov/wp-content/uploads/sites/12/dph/pdf/orcplanreview.pdf"
      },
      {
        "text": "the Machine Verification Form (R1-C)",
        "href": "https://dhss.delaware.gov/wp-content/uploads/sites/12/dph/pdf/radmv.pdf"
      },
      {
        "text": "Delaware\u2019s Radiation Machine Forms Page",
        "href": "https://dhss.delaware.gov/dph/homepage/about/sections/hsp/licenses-and-permits/radiation-control/radiation-machine-facilities/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "district-of-columbia",
    "name": "District of Columbia",
    "guideSlug": "how-to-register-an-x-ray-machine-in-district-of-columbia-a-simple-step-by-step-guide",
    "quickAnswer": "DC Health registers radiation-producing machines through the Division of Radiation Control and Medical Devices. The division's online portal accepts Radiation Producing Machines applications, supporting documents, and payment. DC Health stopped accepting paper applications for this division effective April 10, 2023.",
    "links": [
      {
        "text": "DC Radiation Control & Medical Devices",
        "href": "https://dchealth.dc.gov/service/radiation-control-medical-devices-division"
      },
      {
        "text": "DC Radiation Protection Forms",
        "href": "https://dchealth.dc.gov/service/radiation-protection-services-and-forms"
      },
      {
        "text": "DC Radiation-Producing Machine Registration Forms",
        "href": "https://dchealth.dc.gov/service/radiation-producing-machines-registration-forms"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "florida",
    "name": "Florida",
    "guideSlug": "how-to-register-an-x-ray-machine-in-florida-a-simple-step-by-step-guide",
    "quickAnswer": "Florida requires radiation-producing machines to be registered with the Department of Health. New registrants and newly acquired machines generally have a 30-day filing/payment window, and machine registration fees are assessed annually.",
    "links": [
      {
        "text": "Florida Radiation Machine Registration",
        "href": "https://www.floridahealth.gov/licensing-regulations/radiation-control/ionizing-radiation-machines-x-ray/"
      },
      {
        "text": "the Florida X-Ray Fee Schedule",
        "href": "https://www.floridahealth.gov/environmental-health/radiation-control/ion/_documents/Radiation-Machine-Registration-Fee-Schedule.pdf"
      },
      {
        "text": "Florida X-Ray Online Payment",
        "href": "https://xray.floridahealth.gov/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "georgia",
    "name": "Georgia",
    "guideSlug": "how-to-register-an-x-ray-machine-in-georgia-a-simple-step-by-step-guide",
    "quickAnswer": "Georgia requires an X-ray facility to be registered before operation. The Department's current process is online, and the registration package may require facility identity documents and shielding information for permanently installed X-ray rooms.",
    "links": [
      {
        "text": "Georgia X-Ray Registration Information",
        "href": "https://dch.georgia.gov/divisionsoffices/hfrd/facilities-provider-information/x-ray"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "hawaii",
    "name": "Hawaii",
    "guideSlug": "how-to-register-an-x-ray-machine-in-hawaii-a-simple-step-by-step-guide",
    "quickAnswer": "Hawaii requires a radiation facility license before acquiring, installing, possessing, or using electronic ionizing-radiation equipment. The state advises submitting the application and fee well before the planned installation because processing can take 30 days or more.",
    "links": [
      {
        "text": "Hawaii Radiation Forms",
        "href": "https://health.hawaii.gov/irhb/radforms/"
      },
      {
        "text": "Hawaii Radiation Facility License Application",
        "href": "https://health.hawaii.gov/irhb/files/2013/07/radlicenseapp.pdf"
      },
      {
        "text": "Hawaii Radiation License Information",
        "href": "https://health.hawaii.gov/irhb/files/2013/07/radlicenseinfo.pdf"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "idaho",
    "name": "Idaho",
    "guideSlug": "how-to-register-an-x-ray-machine-in-idaho-a-simple-step-by-step-guide",
    "quickAnswer": "Complete Idaho\u2019s online X-Ray Licensure Application. New hospital, medical, and chiropractic facilities must submit the shielding plan before licensing. Idaho also requires a qualified-expert shielding review, and the facility sends a copy to the program within 30 days after receiving it.",
    "links": [
      {
        "text": "Start the Online X-Ray License Application",
        "href": "https://app.keysurvey.com/f/41799329/6cd0/"
      },
      {
        "text": "the X-Ray Change of Information Form",
        "href": "https://app.keysurvey.com/f/41850267/84eb/"
      },
      {
        "text": "the Notice of Installation",
        "href": "https://app.keysurvey.com/f/41545218/7b8d/"
      },
      {
        "text": "Idaho\u2019s X-Ray Licensing Page",
        "href": "https://healthandwelfare.idaho.gov/providers/idaho-laboratories-and-testing/x-ray-licensure"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "illinois",
    "name": "Illinois",
    "guideSlug": "how-to-register-an-x-ray-machine-in-illinois-a-simple-step-by-step-guide",
    "quickAnswer": "A new Illinois X-ray facility uses the paper facility-registration form. Send the signed form to IEMA-OHS before the machine is used. Registration and machine fees are billed every year.",
    "links": [
      {
        "text": "the Illinois Facility Registration Form",
        "href": "https://iemaohs.illinois.gov/content/dam/soi/en/web/iemaohs/nrs/radsafety/documents/fac-reg.pdf"
      },
      {
        "text": "Illinois Registration Instructions",
        "href": "https://iemaohs.illinois.gov/nrs/radsafety/xray-change.html"
      },
      {
        "text": "the Illinois X-Ray Program",
        "href": "https://iemaohs.illinois.gov/nrs/radsafety/xray.html"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "indiana",
    "name": "Indiana",
    "guideSlug": "how-to-register-an-x-ray-machine-in-indiana-a-simple-step-by-step-guide",
    "quickAnswer": "Indiana requires the facility to register its X-ray machines before operation. Complete Parts A, B, and C of the registration form and send it to the Indiana Department of Health.",
    "links": [
      {
        "text": "the Indiana X-Ray Registration Form",
        "href": "https://forms.in.gov/Download.aspx?id=8060"
      },
      {
        "text": "the Indiana Radiology Program",
        "href": "https://www.in.gov/health/cshcr/radiology-weights-and-measures"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "iowa",
    "name": "Iowa",
    "guideSlug": "how-to-register-an-x-ray-machine-in-iowa-a-simple-step-by-step-guide",
    "quickAnswer": "Iowa registers radiation-producing machines through its Regulatory Licensing Portal. A new medical facility or new medical X-ray installation also needs a shielding review. A stationary machine may not be used until the required shielding review and registration steps are complete.",
    "links": [
      {
        "text": "the Iowa Regulatory Licensing Portal",
        "href": "https://amanda-portal.idph.state.ia.us/"
      },
      {
        "text": "the Iowa Installation Checklist",
        "href": "https://hhs.iowa.gov/media/7552/download?inline="
      },
      {
        "text": "Iowa X-Ray Machine Instructions",
        "href": "https://hhs.iowa.gov/health-prevention/providers-professionals/radiological-health/x-ray-machines"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "kansas",
    "name": "Kansas",
    "guideSlug": "how-to-register-an-x-ray-machine-in-kansas-a-simple-step-by-step-guide",
    "quickAnswer": "Kansas requires radiation-producing equipment to be registered. The current registration packet states that the registration form and fee are due within 30 days of acquiring X-ray devices, and the initial package includes shielding-plan information.",
    "links": [
      {
        "text": "the Kansas X-Ray Registration Packet",
        "href": "https://www.kdhe.ks.gov/DocumentCenter/View/10420"
      },
      {
        "text": "KDHE Radiation Information",
        "href": "https://www.kdhe.ks.gov/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "kentucky",
    "name": "Kentucky",
    "guideSlug": "how-to-register-an-x-ray-machine-in-kentucky-a-simple-step-by-step-guide",
    "quickAnswer": "Kentucky requires radiation-producing machines to be registered and does not allow operation without a valid registration. Registration is renewed annually, and fees depend on the number and type of machines.",
    "links": [
      {
        "text": "Kentucky Form RPS-402",
        "href": "https://www.chfs.ky.gov/agencies/dph/dphps/rhb/Documents/RPS402%20Application%20Rev%209_23.pdf"
      },
      {
        "text": "Kentucky Radiation Producing Machines",
        "href": "https://www.chfs.ky.gov/agencies/dph/dphps/rhb/Pages/rpmp.aspx"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "louisiana",
    "name": "Louisiana",
    "guideSlug": "how-to-register-an-x-ray-machine-in-louisiana-a-simple-step-by-step-guide",
    "quickAnswer": "Louisiana uses Form DRC-6 to register each X-ray machine. Send one completed form for each unit. Most new fixed rooms need an approved shielding plan before construction, except for the specific low-risk room types listed by the state.",
    "links": [
      {
        "text": "Louisiana Form DRC-6",
        "href": "https://www.deq.louisiana.gov/assets/docs/Radiation/DRC-6-XRay-Machine-Reg-App_rev6-26.pdf"
      },
      {
        "text": "Louisiana Radiation Forms",
        "href": "https://www.deq.louisiana.gov/radiation-forms-and-applications"
      },
      {
        "text": "the Louisiana Radiation Program",
        "href": "https://www.deq.louisiana.gov/radiation"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "maine",
    "name": "Maine",
    "guideSlug": "how-to-register-an-x-ray-machine-in-maine-a-simple-step-by-step-guide",
    "quickAnswer": "A new Maine X-ray facility submits the initial fee form and the radiation-machine form. Most new rooms need a shielding design accepted by the Radiation Control Program before the machine registration can be processed.",
    "links": [
      {
        "text": "Maine Initial Fee Form HHE-804",
        "href": "https://www.maine.gov/dhhs/mecdc/environmental-health/rad/documents/forms/hhe-804%20new%20x-ray%20registration.pdf"
      },
      {
        "text": "Maine Machine Form HHE-805",
        "href": "https://www.maine.gov/dhhs/mecdc/environmental-health/rad/documents/forms/hhe-805-radiation-machine-registration.pdf"
      },
      {
        "text": "Maine X-Ray Licensing Instructions",
        "href": "https://www1.maine.gov/dhhs/mecdc/services/radiation-control-nuclear-safety/x-ray-licensing"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "maryland",
    "name": "Maryland",
    "guideSlug": "how-to-register-an-x-ray-machine-in-maryland-a-simple-step-by-step-guide",
    "quickAnswer": "Maryland requires radiation machines to be registered before use. A new-machine package includes the registration application, installation reports, required professional credentials for applicable modalities, the registration fee, and equipment maintenance information.",
    "links": [
      {
        "text": "Maryland New X-Ray Machine Registration Instructions",
        "href": "https://mde.maryland.gov/programs/air/RadiologicalHealth/Documents/www.mde.state.md.us/assets/document/air/Instructions_for_Registering_New_Machines_26.pdf"
      },
      {
        "text": "Maryland Radiological Health",
        "href": "https://mde.maryland.gov/programs/Air/RadiologicalHealth/Pages/index.aspx"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "massachusetts",
    "name": "Massachusetts",
    "guideSlug": "how-to-register-an-x-ray-machine-in-massachusetts-a-simple-step-by-step-guide",
    "quickAnswer": "Massachusetts requires medical, dental, therapy, and analytical ionizing-radiation sources to be registered online through the Environmental Health eLicensing Portal.",
    "links": [
      {
        "text": "Start the Massachusetts Registration Process",
        "href": "https://www.mass.gov/how-to/register-an-ionizing-radiation-source"
      },
      {
        "text": "Massachusetts Radiation Control",
        "href": "https://www.mass.gov/radiation-control"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "michigan",
    "name": "Michigan",
    "guideSlug": "how-to-register-an-x-ray-machine-in-michigan-a-simple-step-by-step-guide",
    "quickAnswer": "Michigan requires every X-ray facility to register through the Radiation Safety Section portal before the machine is used. Many new or changed rooms also require shielding-plan approval.",
    "links": [
      {
        "text": "the Michigan Radiation Safety Portal",
        "href": "https://aca3.accela.com/MIHS/"
      },
      {
        "text": "Michigan New-Facility Instructions",
        "href": "https://www.michigan.gov/leo/bureaus-agencies/miosha/divisions/technical-services-division/rad-safety/planning-or-starting-up-a-new-x-ray-facility"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "minnesota",
    "name": "Minnesota",
    "guideSlug": "how-to-register-an-x-ray-machine-in-minnesota-a-simple-step-by-step-guide",
    "quickAnswer": "A brand-new Minnesota facility or new owner mails the Initial Registration Form and payment before first use. After payment, the state sends an invitation to finish the equipment record in the online X-ray Registration System.",
    "links": [
      {
        "text": "the Minnesota Initial Registration Form",
        "href": "https://www.health.state.mn.us/communities/environment/radiation/docs/irform.pdf"
      },
      {
        "text": "the Minnesota X-Ray Registration System",
        "href": "https://xray.web.health.state.mn.us/"
      },
      {
        "text": "Minnesota Registration Instructions",
        "href": "https://www.health.state.mn.us/communities/environment/radiation/xray/forms.html"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "mississippi",
    "name": "Mississippi",
    "guideSlug": "how-to-register-an-x-ray-machine-in-mississippi-a-simple-step-by-step-guide",
    "quickAnswer": "Mississippi uses an online DocuSign application for healing-arts or veterinary X-ray units. Industrial and other ionizing-radiation devices use a different DocuSign application.",
    "links": [
      {
        "text": "Start Healing Arts or Veterinary X-Ray Registration",
        "href": "https://powerforms.docusign.net/292fca76-459e-40b1-b8e2-0fc5b44c9030?accountId=ca3d40be-4f16-4a6a-892e-a0fe14f1a6ef&acct=ca3d40be-4f16-4a6a-892e-a0fe14f1a6ef&env=na3"
      },
      {
        "text": "Start Industrial or Other Device Registration",
        "href": "https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=37e76750-1d42-4813-a699-16ff59c6d566&acct=ca3d40be-4f16-4a6a-892e-a0fe14f1a6ef&env=na3&v=2"
      },
      {
        "text": "Mississippi Radiation Applications",
        "href": "https://msdh.ms.gov/page/30%2C0%2C102%2C1058.html"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "missouri",
    "name": "Missouri",
    "guideSlug": "how-to-register-an-x-ray-machine-in-missouri-a-simple-step-by-step-guide",
    "quickAnswer": "Missouri facilities register diagnostic X-ray machines with the Missouri Radiation Control Program. Complete the medical radiation registration form, list every machine, and send the signed form to the program.",
    "links": [
      {
        "text": "the Missouri Medical Radiation Registration Form",
        "href": "https://health.mo.gov/safety/radprotection/pdf/MoMedRadRegForm.pdf"
      },
      {
        "text": "Missouri Radiation Forms",
        "href": "https://health.mo.gov/providers/radiation-control/applications-forms"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "montana",
    "name": "Montana",
    "guideSlug": "how-to-register-an-x-ray-machine-in-montana-a-simple-step-by-step-guide",
    "quickAnswer": "Montana requires a radiation machine to be registered within 30 days of possession. The state's current process is online, and registered machines are re-registered every two years.",
    "links": [
      {
        "text": "Montana Radiation Machine Registration",
        "href": "https://dphhs.mt.gov/qad/radiationmachineregistration"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "nebraska",
    "name": "Nebraska",
    "guideSlug": "how-to-register-an-x-ray-machine-in-nebraska-a-simple-step-by-step-guide",
    "quickAnswer": "Nebraska requires each X-ray facility to submit Form NRH-4 and the applicable fee within 30 days after operations begin. Registration expires every year.",
    "links": [
      {
        "text": "Nebraska Form NRH-4",
        "href": "https://dhhs.ne.gov/Radiation%20Control%20%20Documents/NRH-4%20-%20Fill.pdf"
      },
      {
        "text": "the NRH-4 Instructions",
        "href": "https://dhhs.ne.gov/Radiation%20Control%20%20Documents/NRH-4INST.pdf"
      },
      {
        "text": "Nebraska X-Ray Registration Instructions",
        "href": "https://dhhs.ne.gov/Pages/Radiation-Control-X-Ray-Registrations.aspx"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "nevada",
    "name": "Nevada",
    "guideSlug": "how-to-register-an-x-ray-machine-in-nevada-a-simple-step-by-step-guide",
    "quickAnswer": "Nevada registers facility X-ray machines through the CLICS online system. The facility is responsible for the registration and fees, and the certificate must be posted before use. The state says processing may take about 30 days.",
    "links": [
      {
        "text": "Nevada CLICS",
        "href": "https://nvrcp.aithent.com/"
      },
      {
        "text": "Nevada Machine Forms and Instructions",
        "href": "https://www.dpbh.nv.gov/regulatory/radiation-control-programs/radiation-producing-machines-program-rpm/forms/"
      },
      {
        "text": "Read Nevada Machine Registration FAQs",
        "href": "https://www.dpbh.nv.gov/regulatory/radiation-control-programs/radiation-producing-machines-program-rpm/faqs/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "new-hampshire",
    "name": "New Hampshire",
    "guideSlug": "how-to-register-an-x-ray-machine-in-new-hampshire-a-simple-step-by-step-guide",
    "quickAnswer": "New Hampshire requires one original, signed machine-registration application for each X-ray or MRI unit. Send it to the Radiological Health Section with the fee, business-registration proof, and installer records.",
    "links": [
      {
        "text": "the New Hampshire Machine Application",
        "href": "https://www.dhhs.nh.gov/sites/g/files/ehbemt476/files/inline-documents/sonh/rhs-a-machineapp_0.pdf"
      },
      {
        "text": "New Hampshire Radiological Health",
        "href": "https://www.dhhs.nh.gov/programs-services/environmental-health-and-you/radiological-health"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "new-jersey",
    "name": "New Jersey",
    "guideSlug": "how-to-register-an-x-ray-machine-in-new-jersey-a-simple-step-by-step-guide",
    "quickAnswer": "New Jersey requires the facility to submit both pages of the X-ray registration form within 30 days after installation. Do not send payment with the form; the state sends an invoice later.",
    "links": [
      {
        "text": "the New Jersey X-Ray Registration Form",
        "href": "https://www.nj.gov/dep/rpp/reg/downloads/xrayreg.pdf"
      },
      {
        "text": "New Jersey X-Ray Registration Services",
        "href": "https://www.xray.nj.gov/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "new-mexico",
    "name": "New Mexico",
    "guideSlug": "how-to-register-an-x-ray-machine-in-new-mexico-a-simple-step-by-step-guide",
    "quickAnswer": "New Mexico uses one Registration to Operate Radiation Machines form for new applications, renewals, and amendments. Email is the state's preferred submission method.",
    "links": [
      {
        "text": "the New Mexico Registration Form",
        "href": "https://www.env.nm.gov/rcb/wp-content/uploads/sites/16/2025/03/Flattened-Registration-to-Operate-Radiation-Machines-Form.pdf"
      },
      {
        "text": "the New Mexico Radiation Machines Program",
        "href": "https://www.env.nm.gov/rcb/radiation-machines/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "new-york",
    "name": "New York",
    "guideSlug": "how-to-register-an-x-ray-machine-in-new-york-a-simple-step-by-step-guide",
    "quickAnswer": "Outside New York City, a new X-ray practice registers with the New York State Bureau of Environmental Radiation Protection.",
    "links": [
      {
        "text": "New York X-Ray Registration Instructions",
        "href": "https://www.health.ny.gov/environmental/radiological/radon/registration.htm"
      },
      {
        "text": "New York Radiation Equipment FAQs",
        "href": "https://www.health.ny.gov/environmental/radiological/faqs/radequip.htm"
      }
    ],
    "extraGuides": [
      {
        "slug": "how-to-register-an-x-ray-machine-in-new-york-city-a-simple-step-by-step-guide",
        "name": "New York City"
      }
    ]
  },
  {
    "slug": "north-carolina",
    "name": "North Carolina",
    "guideSlug": "how-to-register-an-x-ray-machine-in-north-carolina-a-simple-step-by-step-guide",
    "quickAnswer": "North Carolina requires a facility and each radiation machine to be registered. The rule requires registration within 30 days following initial operation, and registration fees are assessed when the registration is issued and annually on July 1.",
    "links": [
      {
        "text": "North Carolina X-Ray Applications",
        "href": "https://radiation.ncdhhs.gov/xray/applic.htm"
      },
      {
        "text": "North Carolina Registration Information",
        "href": "https://radiation.ncdhhs.gov/Xray/documents/RegistrationInformation.pdf"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "north-dakota",
    "name": "North Dakota",
    "guideSlug": "how-to-register-an-x-ray-machine-in-north-dakota-a-simple-step-by-step-guide",
    "quickAnswer": "North Dakota requires X-ray facilities to register radiation machines. The current program instructs facilities to apply within 30 days following installation, and the registration fee shown on the state form covers a three-year registration period.",
    "links": [
      {
        "text": "North Dakota X-Ray Registration",
        "href": "https://deq.nd.gov/wm/radiation/x-ray.aspx"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "ohio",
    "name": "Ohio",
    "guideSlug": "how-to-register-an-x-ray-machine-in-ohio-a-simple-step-by-step-guide",
    "quickAnswer": "Ohio requires a radiation-generating-equipment facility to apply for registration at least 30 days before handling or operating the equipment. Registrations are generally valid for two years, and Ohio law sets a biennial radiation-generating-equipment registration fee.",
    "links": [
      {
        "text": "Ohio Radiation-Generating Equipment Registration Rule",
        "href": "https://codes.ohio.gov/ohio-administrative-code/rule-3701:1-38-03"
      },
      {
        "text": "Ohio Registration Fee Law",
        "href": "https://codes.ohio.gov/ohio-revised-code/section-3748.07"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "oklahoma",
    "name": "Oklahoma",
    "guideSlug": "how-to-register-an-x-ray-machine-in-oklahoma-a-simple-step-by-step-guide",
    "quickAnswer": "Oklahoma requires a permit to operate diagnostic X-ray equipment. As of April 22, 2026, the Oklahoma State Department of Health moved its initial and renewal licensing process online.",
    "links": [
      {
        "text": "Oklahoma Diagnostic X-Ray Licensing",
        "href": "https://www.oklahoma.gov/health/services/licensing-inspections/consumer-health-service/licensure/x-ray.html"
      },
      {
        "text": "Oklahoma DEQ Radiation Program",
        "href": "https://oklahoma.gov/deq/divisions/land-protection/radiation.html"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "oregon",
    "name": "Oregon",
    "guideSlug": "how-to-register-an-x-ray-machine-in-oregon-a-simple-step-by-step-guide",
    "quickAnswer": "Oregon uses a paper X-ray registration application. Send the completed form, then wait for the state invoice. The form says a facility may operate after the application is submitted, but it must follow every safety and licensing rule.",
    "links": [
      {
        "text": "the Oregon X-Ray Registration Application",
        "href": "https://www.oregon.gov/oha/ph/HealthyEnvironments/RadiationProtection/xray/Documents/registrationapplication.pdf"
      },
      {
        "text": "Oregon Registration Instructions",
        "href": "https://www.oregon.gov/oha/ph/healthyenvironments/radiationprotection/xray/pages/registration.aspx"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "pennsylvania",
    "name": "Pennsylvania",
    "guideSlug": "how-to-register-an-x-ray-machine-in-pennsylvania-a-simple-step-by-step-guide",
    "quickAnswer": "Pennsylvania requires the facility to register each radiation-producing machine within 30 days after acquiring it. Mail the registration form and the full fee to the Department of Environmental Protection.",
    "links": [
      {
        "text": "the Pennsylvania Registration Form",
        "href": "https://greenport.pa.gov/elibrary/PDFProvider.ashx?PromptToSave=False&Size=170261&ViewerMode=2&action=PDFStream&docID=1489395&docName=02+REGISTRATION+FORM&nativeExt=pdf&overlay=0&revision=1"
      },
      {
        "text": "Pennsylvania Machine Registration Instructions",
        "href": "https://www.pa.gov/services/dep/register-a-radiation-producing-machine"
      },
      {
        "text": "Pennsylvania GreenPort Renewal Information",
        "href": "https://www.pa.gov/agencies/dep/programs-and-services/business/epermitting/radiation-protection-epermitting"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "rhode-island",
    "name": "Rhode Island",
    "guideSlug": "how-to-register-an-x-ray-machine-in-rhode-island-a-simple-step-by-step-guide",
    "quickAnswer": "Rhode Island uses a different X-ray facility application for each facility type. The application must include the required fee and an attached shielding plan and evaluation.",
    "links": [
      {
        "text": "the Specific Radiology Facility Application",
        "href": "https://health.ri.gov/sites/g/files/xkgbur1006/files/applications/XRaySpecificRadiologyFacility.pdf"
      },
      {
        "text": "the Dental Facility Application",
        "href": "https://health.ri.gov/sites/g/files/xkgbur1006/files/applications/XRayDental.pdf"
      },
      {
        "text": "the General Radiology Facility Application",
        "href": "https://health.ri.gov/sites/g/files/xkgbur1006/files/applications/XRayRADFacility.pdf"
      },
      {
        "text": "All Rhode Island Radiation Applications",
        "href": "https://health.ri.gov/about-us/ridoh-programs-centers-divisions/radiation-control-program"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "south-carolina",
    "name": "South Carolina",
    "guideSlug": "how-to-register-an-x-ray-machine-in-south-carolina-a-simple-step-by-step-guide",
    "quickAnswer": "South Carolina uses a two-step process for many X-ray facilities: obtain Facility Registration Approval before installation, then register the installed X-ray equipment. The state says a facility must not install the machine before the required Facility Registration Approval is issued.",
    "links": [
      {
        "text": "South Carolina X-Ray Registration Guide",
        "href": "https://des.sc.gov/sites/des/files/Documents/BLWM/RadProtection/B1_Registration.pdf"
      },
      {
        "text": "South Carolina Shielding Plan Requirements",
        "href": "https://www.des.sc.gov/programs/bureau-land-waste-management/radiation-protection-program/shielding-plan-requirements"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "south-dakota",
    "name": "South Dakota",
    "guideSlug": "how-to-register-an-x-ray-machine-in-south-dakota-a-simple-step-by-step-guide",
    "quickAnswer": "South Dakota treats an X-ray facility as a licensed healthcare facility. Apply through the state's healthcare licensing system. The license renews every year, and the X-ray facility must be surveyed at least every three years by a state inspector or physicist.",
    "links": [
      {
        "text": "Start the South Dakota X-Ray Facility Application",
        "href": "https://www.sdhls.org/"
      },
      {
        "text": "South Dakota X-Ray Facility Instructions",
        "href": "https://doh.sd.gov/healthcare-professionals/health-facility-licensure/prepare-for-x-ray-facility-inspection/"
      },
      {
        "text": "General Facility Licensing Instructions",
        "href": "https://doh.sd.gov/healthcare-professionals/health-facility-licensure/healthcare-facility-licensure/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "tennessee",
    "name": "Tennessee",
    "guideSlug": "how-to-register-an-x-ray-machine-in-tennessee-a-simple-step-by-step-guide",
    "quickAnswer": "Tennessee requires X-ray equipment to be registered with the state's X-Ray Registration program. Current 2026 guidance instructs a registrant that acquires a new X-ray unit to register it within 10 days of possession. Annual fees depend on the equipment class.",
    "links": [
      {
        "text": "Tennessee X-Ray Registration Information",
        "href": "https://www.tn.gov/environment/permits/radiological-health/xray-registration.html"
      },
      {
        "text": "Tennessee X-Ray Installer Information",
        "href": "https://www.tn.gov/environment/permits/radiological-health/xray-registration/xray-installers.html"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "texas",
    "name": "Texas",
    "guideSlug": "how-to-register-an-x-ray-machine-in-texas-a-simple-step-by-step-guide",
    "quickAnswer": "Texas requires a Certificate of Registration before regulated radiation-machine operations begin. The current registration application is RC Form 226-2, revised in 2026, and the application package includes the machine/facility information and other business or RSO documents that apply to the facility.",
    "links": [
      {
        "text": "Texas RC Form 226-2",
        "href": "https://www.dshs.texas.gov/sites/default/files/radiation/x-ray/pdf/rc-226-02-rad-machine-app.pdf"
      },
      {
        "text": "Texas Radiation Control",
        "href": "https://www.dshs.texas.gov/texas-radiation-control"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "utah",
    "name": "Utah",
    "guideSlug": "how-to-register-an-x-ray-machine-in-utah-a-simple-step-by-step-guide",
    "quickAnswer": "Utah uses the Division of Waste Management and Radiation Control Community Portal for new X-ray machine registration, renewals, and changes. Registration is annual.",
    "links": [
      {
        "text": "the Utah Community Portal",
        "href": "https://deqorg.utah.gov/"
      },
      {
        "text": "Utah X-Ray Forms and Instructions",
        "href": "https://deq.utah.gov/dwmrc/x-ray-forms"
      },
      {
        "text": "Utah New-Registration Instructions",
        "href": "https://lf-public.deq.utah.gov/WebLink/ElectronicFile.aspx?dbid=0&docid=438439&eqdocs=DSHW-2023-001579&repo=Public"
      },
      {
        "text": "Utah Fees and Inspection Information",
        "href": "https://deq.utah.gov/waste-management-and-radiation-control/inspections-registrations-and-fees-x-ray-program"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "vermont",
    "name": "Vermont",
    "guideSlug": "how-to-register-an-x-ray-machine-in-vermont-a-simple-step-by-step-guide",
    "quickAnswer": "Vermont's radiation-machine registration is online and must be renewed every year. Submit the online machine form, wait for the emailed invoice, pay it, and then print the certificate sent by email.",
    "links": [
      {
        "text": "Start the Vermont 2026 Machine Registration",
        "href": "https://forms.office.com/Pages/ResponsePage.aspx?id=O5O0IK26PEOcAnDtzHVZxmpH3mmaZbVPvxp6TcPbADZUN05HMUU3SkkxWjEwOUpEMjdNV0I3NlM0UyQlQCN0PWcu"
      },
      {
        "text": "Vermont X-Ray Registration Instructions",
        "href": "https://www.healthvermont.gov/environment/radiological-health/x-rays"
      },
      {
        "text": "Vermont Online Payment",
        "href": "https://vt.accessgov.com/xray/Forms/Page/xray/registration/0"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "virginia",
    "name": "Virginia",
    "guideSlug": "how-to-register-an-x-ray-machine-in-virginia-a-simple-step-by-step-guide",
    "quickAnswer": "Virginia requires X-ray machines to be registered with the Office of Radiological Health, subject to limited exceptions. The medical registration process instructs facilities to register within 30 days following installation and request the required initial inspection.",
    "links": [
      {
        "text": "Virginia Medical X-Ray Machine Registration",
        "href": "https://www.vdh.virginia.gov/radiological-health/radiological-health/x-ray-machine-program/medical-x-ray-machines/"
      },
      {
        "text": "Virginia Form RH-F-2",
        "href": "https://www.vdh.virginia.gov/content/uploads/sites/7/2019/12/Form-0120-MedicalRegistration.pdf"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "washington",
    "name": "Washington",
    "guideSlug": "how-to-register-an-x-ray-machine-in-washington-a-simple-step-by-step-guide",
    "quickAnswer": "Washington registers X-ray facilities and devices through the Department of Revenue Business Licensing Service. New, remodeled, or moved medical X-ray rooms need shielding calculations before construction or relocation.",
    "links": [
      {
        "text": "Start Washington Business Licensing Online",
        "href": "https://dor.wa.gov/open-business/apply-business-license"
      },
      {
        "text": "Washington X-Ray Registration Instructions",
        "href": "https://doh.wa.gov/community-and-environment/radiation/x-ray/x-ray-equipment-registration"
      },
      {
        "text": "Washington Mail-In Registration Instructions and Forms",
        "href": "https://doh.wa.gov/community-and-environment/radiation/x-ray/new-x-ray-registration"
      },
      {
        "text": "Washington X-Ray Facility Plan Review",
        "href": "https://doh.wa.gov/community-and-environment/radiation/x-ray/x-ray-equipment-registration/x-ray-facility-plan-review"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "west-virginia",
    "name": "West Virginia",
    "guideSlug": "how-to-register-an-x-ray-machine-in-west-virginia-a-simple-step-by-step-guide",
    "quickAnswer": "West Virginia requires radiation machines to be registered with the Radiological Health Program before operation. The program lists Form 1R for radiation-machine registration and requires facilities to keep the machine registration current.",
    "links": [
      {
        "text": "West Virginia Radiological Health",
        "href": "https://oehs.wvdhhr.org/rtia/radiological-health/"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "wisconsin",
    "name": "Wisconsin",
    "guideSlug": "how-to-register-an-x-ray-machine-in-wisconsin-a-simple-step-by-step-guide",
    "quickAnswer": "Wisconsin requires all X-ray devices to be registered with the Department of Health Services. Registrations are annual and expire December 31.",
    "links": [
      {
        "text": "Wisconsin X-Ray Registration",
        "href": "https://www.dhs.wisconsin.gov/radiation/xray/registration.htm"
      },
      {
        "text": "the Wisconsin X-Ray Fee Schedule",
        "href": "https://www.dhs.wisconsin.gov/radiation/xray/feeschedule.htm"
      },
      {
        "text": "the Wisconsin X-Ray Program",
        "href": "https://www.dhs.wisconsin.gov/radiation/xray/index.htm"
      }
    ],
    "extraGuides": []
  },
  {
    "slug": "wyoming",
    "name": "Wyoming",
    "guideSlug": "how-to-register-an-x-ray-machine-in-wyoming-a-simple-step-by-step-guide",
    "quickAnswer": "Wyoming has jurisdiction over X-ray equipment, but current public materials do not present one general statewide machine-registration portal that clearly applies to every type of X-ray facility.",
    "links": [
      {
        "text": "Wyoming Dental X-Ray Inspection Information",
        "href": "https://dental.wyo.gov/licensing/x-ray-inspection-forms"
      }
    ],
    "extraGuides": []
  }
];
